// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__1Tpd9","header":"ClearentDisclaimer_header__3f2oQ","inner":"ClearentDisclaimer_inner__1qz-J"};